import _ from "lodash";
import { IIssueRatingCategory, IUserSkill } from "types";

export function buildSkills(data?: Partial<IUserSkill>[]) {
  const items = data?.map((entry) => {
    const skill = entry.skill;
    if (!skill) return undefined;
    return {
      value: skill.id || "",
      label: skill.name,
      description: skill.description,
    };
  });
  return _.compact(items);
}

export function buildCategories(data?: Partial<IIssueRatingCategory>[]) {
  const items = data?.map((category) => {
    if (!category) return undefined;
    return {
      value: category.id,
      label: category.title,
      description: category.description,
    };
  });
  return _.compact(items);
}
